import { DEFAULT_CORP_PAGE_CONFIG } from '@scale/frontend-lib/page-config';

const getPageConfig = () => DEFAULT_CORP_PAGE_CONFIG;

export default getPageConfig;
